/** Case prototypes are opt-in during development and never exposed by a production build. */
export function isCasePreviewEnabled(): boolean {
  return (
    import.meta.env.DEV &&
    import.meta.env.VITE_CPQ_CASE_PREVIEW_ENABLED === 'true'
  );
}

export function isCaseView(view: string): boolean {
  return view === 'cases' || view === 'case-admin';
}
